import React from 'react'
import { useParams } from 'react-router-dom'

import { RequestContent } from '../RepairAndInquiries/components'
import { REPAIR_AND_INQUIRIES_STATUSES as STATUSES } from '../../../constants/repairAndInquiriesStatuses'

export const RepairAndInquiriesDetail = () => {
  const { code } = useParams<{ code: string }>()

  const activeItem = {
    code: code ?? '',
    contract_number: '',
    create_date: '',
    description: '',
    main_issue: '',
    status: '',
    subject: '',
    urgency: '',
    contacted_via: '',
    zFeedbackTenantAppKTU: '',
    user_comment: [],
  }

  return (
    <div>
      <RequestContent statuses={STATUSES} activeItem={activeItem} />
    </div>
  )
}
